import * as programActionTypes from "../../../actions/input/program/programActionTypes";
import * as persistenceActions from "../../../actions/persistence/persistenceActions";
import * as priorStateActions from "../../../actions/temp/priorState/priorStateActions";
import * as logger from "common/logger";
import { put, takeLatest } from "redux-saga/effects";

export function* updatePriorSubmission(action) {
  try {
    const priorSubmissionFilename = action.payload;
    if (priorSubmissionFilename) {
      yield put(
        persistenceActions.loadPriorSubmission(priorSubmissionFilename)
      );
    } else {
      yield put(priorStateActions.clearPriorState());
    }
  } catch (e) {
    logger.exception(e);
  }
}

export default function* programSaga() {
  yield takeLatest(
    programActionTypes.UPDATE_PRIOR_SUBMISSION,
    updatePriorSubmission
  );
}
